import CreateProfilePage from "@/pages/create-profile/CreateProfilePage";

export default function EditProfile() {
  return <CreateProfilePage mode="edit" />;
}
